import PropTypes from 'prop-types';
import { useState, useRef, useEffect, useCallback } from 'react';
// @mui
import { styled, useTheme } from '@mui/material/styles';
import {
    Box,
    Stack,
    Drawer,
    MenuItem,
    Typography,
    Container,
    IconButton,
    Menu,
    useMediaQuery,
    CardContent,
    Divider
} from '@mui/material';
import { Button } from 'src/@/components/ui/button';
import { useDispatch, useSelector } from 'react-redux';
import useAuth from 'src/hooks/useAuth';
import Iconify from 'src/components/Iconify';
import DrawerNegocioHead from './components/DrawerNegocioHead';
import DrawerNegocioNotas from './components/DrawerNegocioNotas';
import InputStyle from 'src/components/InputStyle';
import DrawerNegocioTimeline from './components/DrawerNegocioTimeline';
import { useSnackbar } from 'notistack';
import LabelIcon from 'src/components/LabelIcon';
import DrawerContatos from './components/DrawerContatos';
import DrawerChatWhatsapp from 'src/sections/@chats/chat/DrawerChatWhatsapp';
import { getChatInfoByChatId, getMensagensWhatsappDb, setChatInfo } from 'src/redux/slices/chat';

import ModalConfimacao from 'src/components/modal/ModalConfimacao';
import Scrollbar from 'src/components/Scrollbar';
import { fDate, fDateTime, fTime, fToNow } from 'src/utils/formatTime';

//actions
import v2_actionDetalhesLead from 'src/actions/v2/crm/v2_actionDetalhesLead';
import v2_actionDeletarLead from 'src/actions/v2/crm/v2_actionDeletarLead';
import v2_actionEditarLead from 'src/actions/v2/crm/v2_actionEditarLead';

import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
} from "src/@/components/ui/tabs"
import { Card } from 'src/@/components/ui/card';
import DrawerTransferirLead from './components/DrawerTransferirLead';
import ComponentCloseLead from './components/ComponentCloseLead';


import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "src/@/components/ui/dialog"
import { Input } from "src/@/components/ui/input"
import { Label } from "src/@/components/ui/label"
import { ChatWindow } from 'src/sections/@chats/chat';
import DrawerTabNegocio from './components/DrawerTabNegocio';
import DrawerConvertLead from './components/DrawerConvertLead';
import { Badge } from 'src/@/components/ui/badge';
import DrawerDeleteLead from './components/DrawerDeleteLead';


const MenuMarcarNegociacao = ({ anchorEl, onClose, open, onSelect }) => {
    return (
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            sx={{}}

            MenuListProps={{
                'aria-labelledby': 'basic-button',
            }}
        >
            <MenuItem sx={{ minWidth: 120 }} onClick={() => onSelect(1)}>
                <Stack alignItems={"center"} spacing={1} direction={"row"}>
                    <Iconify color="green" icon="mdi:cash-plus" />
                    <Typography color="green" variant="subtitle2">Venda</Typography>
                </Stack>
            </MenuItem>
            <MenuItem onClick={() => onSelect(2)}>
                <Stack alignItems={"center"} spacing={1} direction={"row"}>
                    <Iconify color="red" icon="mingcute:sad-fill" />
                    <Typography color="red" variant="subtitle2">Perda</Typography>
                </Stack>
            </MenuItem>
        </Menu>
    )
}


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ px: 0.5, py: 1 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const RowItemHeadDate = ({ title, value }) => {
    return (
        <Stack direction={"column"} spacing={0.2}>
            <Typography variant="extraSmall" >{title}</Typography>
            <Typography fontWeight={'600'} sx={{ fontSize: 11 }}>{value}</Typography>
        </Stack>
    )
}

export default function ModalNegocio({
    configCrm,
    open,
    onClose,
    lead,
    callbackRefreshLeads
}) {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const theme = useTheme();
    const [leadData, setLeadData] = useState(null)
    const { chatInfo } = useSelector((state) => state.chat);
    const { config } = useSelector((state) => state.global);

    const { user, cliente } = useAuth();
    const [conversaoLead, setConversaoLead] = useState(leadData?.convertido)
    const [anchorMarcarNegociacao, setAnchorMarcarNegociacao] = useState(null);
    const openAnchorMarcarNegociacao = Boolean(anchorMarcarNegociacao);
    const [isEditNomeLead, setIsEditNomeLead] = useState(false);
    const [openDrawerChatWhatsapp, setOpenDrawerChatWhatsapp] = useState(false);
    const [openModalConfirmacaoExclusao, setOpenModalConfirmacaoExclusao] = useState(null);
    const [loadingExclusaoLead, setLoadingExclusaoLead] = useState(null);
    const [nomeLead, setNomeLead] = useState(null);
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
    const [sidebarLeft, setSidebarLeft] = useState(false);
    const [openCloseLead, setOpenCloseLead] = useState(false);
    const [openDeleteLead, setOpenDeleteLead] = useState(false);



    function setar(lead) {
        setLeadData(lead)
        setNomeLead(lead?.nome)
    }

    async function handleLoadChat(value, clienteWhatsapp) {
        if (!value) return
        setOpenDrawerChatWhatsapp(true)
        dispatch(getMensagensWhatsappDb(clienteWhatsapp.sessao, value.numero, 1, 10));
        dispatch(setChatInfo(value));
        dispatch(getChatInfoByChatId(value._id, value.funil_id, user.id, true));
    }

    useEffect(() => {
        setar(lead)
        handleLoadChat(lead?.whatsapp, lead?.clienteWhatsapp)

    }, [lead, open]);

    async function buscarDetalhesLead(id) {

        try {
            const result = await v2_actionDetalhesLead(id);
            let data = result.data.data;
            if (data) {
                setLeadData(data);
            }
            console.log('data', data)
            if (data?.whatapp) {
                // dispatch(getMensagensWhatsappDb(data?.clienteWhatsapp?.sessao, value.numero, 1, 10));
                // dispatch(setChatInfo(value));
                // dispatch(getChatInfoByChatId(value._id, value.funil_id, user.id, true));
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function editarLead(action, value) {

        if (action === "editar_conversao") {
            let data = {
                action: action,
                scope: {
                    convertido: value ? Number(value) : null,

                }
            }
            setConversaoLead(value)
            await v2_actionEditarLead(lead._id, data, user.id);
            enqueueSnackbar('Negócio alterado com sucesso', { variant: 'success', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
        } if (action === "editar_contato") {

            let data = {
                action: action,
                scope: {
                    contato_id: value,
                }
            }
            await v2_actionEditarLead(lead._id, data, user.id);
            enqueueSnackbar('Contato alterado com sucesso', { variant: 'success', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
        } if (action === "editar_nome_lead") {

            let data = {
                action: action,
                scope: {
                    nome: value,
                }
            }
            await v2_actionEditarLead(lead._id, data, user.id);
            enqueueSnackbar('Lead alterado com sucesso', { variant: 'success', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
        } if (action === "retomar_lead") {

            let data = {
                action: action,
                scope: value
            }
            await v2_actionEditarLead(lead._id, data, user.id);
            enqueueSnackbar('Lead alterado com sucesso', { variant: 'success', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
        }

        setTimeout(() => {
            buscarDetalhesLead(lead._id);
            callbackRefreshLeads()
        }, 1000);

    }

    const labels = {
        1: 'Venda',
        2: 'Perda',
    };


    async function excluirLead(id) {
        setLoadingExclusaoLead(true)
        try {
            await v2_actionDeletarLead(id);
            onClose();
            callbackRefreshLeads();
            setLoadingExclusaoLead(false)
        } catch (error) {
            setLoadingExclusaoLead(false)
            console.log(error);
        }
    }


    return (

        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent className="flex flex-col min-w-[97%] h-[97%]">
                <div>
                    <div className='gap-2 justify-between flex items-center flex-row mt-2'>
                        <Stack spacing={1} alignItems={'center'} direction={"row"}>
                            <Button
                                variant='secondary'
                                size="icon"
                                onClick={onClose}
                                className="w-8 h-8"
                            >
                                <Iconify icon="material-symbols:arrow-back-ios-new" className="font-[15px]" />
                            </Button>

                            <Stack spacing={1} direction="row">
                                {isEditNomeLead ? (
                                    <Stack alignItems={"center"} direction="row" spacing={1}>
                                        <InputStyle sx={{ width: 400 }} value={nomeLead} onChange={e => setNomeLead(e.target.value)} size="medium" />
                                        <IconButton onClick={() => {
                                            editarLead('editar_nome_lead', nomeLead)
                                        }}>
                                            <Iconify width={22} icon="el:ok-sign" />
                                        </IconButton>
                                    </Stack>

                                ) : (
                                    <Stack alignItems={"center"} direction="row" spacing={1}>
                                        <Typography variant="subtitle1">{leadData?.nome}</Typography>
                                        <IconButton onClick={() => setIsEditNomeLead(true)}>
                                            <Iconify width={18} icon="mdi:pencil" />
                                        </IconButton>
                                    </Stack>
                                )}
                            </Stack>
                        </Stack>
                        <Stack spacing={2} alignItems={"center"} direction={"row"}>
                            <div className='flex flex-row gap-6'>
                                <RowItemHeadDate
                                    title="Criado em"
                                    value={lead?.data_criacao && fDateTime(lead?.data_criacao)}
                                />
                                <RowItemHeadDate
                                    title="Ultima Atualização"
                                    value={lead?.data_modificacao && fToNow(lead?.data_modificacao)}
                                />
                            </div>


                            {leadData?.convertido ? (
                                <Badge variant="secondary" className={`h-8 font-semibold rounded-md ${leadData?.convertido === 1 ? 'bg-green-100 text-green-800 gap-2 hover:bg-green-100 border-1 border-green-500' : 'bg-red-100 text-red-800 gap-2 hover:bg-red-100 border-1 border-red-500'}  cursor-pointer`}>
                                    <div
                                        onClick={async () => {
                                            if(leadData?.closed) {
                                                enqueueSnackbar('Não é possível alterar com o lead finalizado', { variant: 'error', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'right' } });
                                                return;
                                            }
                                            await editarLead('editar_conversao', {
                                                convertido: null,
                                                motivo_perda: null,
                                                data_conversao: null
                                            })
                                            callbackRefreshLeads()
                                        }}
                                        className={`${leadData?.convertido === 1 ? 'hover:bg-green-400 bg-green-400' : 'hover:bg-red-300 bg-red-400'} rounded-lg h-4 w-4 flex justify-center items-center`}>
                                        <Iconify icon="iconamoon:close-bold" className="text-white text-[10px] font-bold" />

                                    </div>
                                    {labels[leadData?.convertido]}
                                </Badge>

                            ) : (
                                <DrawerConvertLead
                                    lead={lead}
                                    user={user}
                                    configCrm={configCrm}
                                    onCallback={() => {
                                        buscarDetalhesLead(lead._id);
                                        callbackRefreshLeads();
                                    }}
                                />
                            )}
                            <div className='gap-3 flex items-center'>

                                {leadData?.closed ? (
                                    <Badge variant="secondary" className="h-8 font-semibold rounded-md bg-violet-100 text-violet-800 gap-2 hover:bg-violet-201000 border-1 border-violet-500  cursor-pointer">
                                        <div 
                                        onClick={async () => {
                                            try {
                                                await editarLead('retomar_lead', {
                                                    closed: false,
                                                    data_finalizacao: null
                                                })
                                                callbackRefreshLeads()
                                            } catch(err) {
                                                console.log(err)
                                            }
                                           
                                        }}
                                        className=' hover:bg-violet-300 bg-violet-400 rounded-lg h-5 w-6 flex justify-center items-center'>
                                            <Iconify icon="icon-park-outline:back" className="text-white" />

                                        </div>
                                        Lead finalizado
                                    </Badge>

                                    // <div
                                    //     className="bg-green-100 flex flex-row gap-1 text- items-center px-4  rounded"
                                    //     onClick={async () => {
                                    //         await editarLead('editar_conversao', null)
                                    //         callbackRefreshLeads()
                                    //     }}

                                    // >
                                    //     Lead finalizado
                                    //     <Iconify onClick={() => alert('teste')} className=" text-slate-600 cursor-pointer" icon="material-symbols:close" />
                                    // </div>

                                ) : (
                                    <ComponentCloseLead
                                        lead={leadData}
                                        onOpen={setOpenCloseLead}
                                        open={openCloseLead}
                                        user={user}
                                        onCallback={() => {
                                            buscarDetalhesLead(lead._id);
                                            callbackRefreshLeads();
                                            onClose();
                                        }}
                                        onOpenChange={() => setOpenCloseLead(!openCloseLead)}
                                    />
                                )}


                                <DrawerTransferirLead
                                       lead={leadData}
                                    user={user}
                                    onCallback={() => {
                                        buscarDetalhesLead(lead._id);
                                        callbackRefreshLeads();
                                        onClose();
                                    }}
                                />



                               <DrawerDeleteLead
                                    lead={leadData}
                                    user={user}
                                    open={openDeleteLead}
                                    onOpenChange={() => setOpenDeleteLead(!openDeleteLead)}
                                    onCallback={() => {
                                        callbackRefreshLeads();
                                        onClose();
                                    }}
                                />

                            </div>

                        </Stack>
                    </div>

                </div>

                <Divider sx={{ borderStyle: 'dashed' }} />


                <div className="flex flex-row gap-6 ">

                    <div className='w-1/4'>
                        <Tabs defaultValue="negocio">
                            <TabsList className="grid grid-cols-4 w-full bg-slate-200">
                                <TabsTrigger value="negocio">Negócio</TabsTrigger>
                                <TabsTrigger value="contatos">Contatos</TabsTrigger>
                                <TabsTrigger value="atividades">Atividades</TabsTrigger>
                                <TabsTrigger value="comentarios">Comentários</TabsTrigger>
                            </TabsList>
                            <div className="">
                                <TabsContent value="negocio">
                                    <DrawerTabNegocio
                                        lead={leadData}
                                        configCrm={configCrm}
                                        user={user}
                                        cliente={cliente}
                                        callbackRefreshLeads={callbackRefreshLeads}
                                        callBackRefreshLead={() => buscarDetalhesLead(lead._id)}
                                        onOpenChatWhatsapp={value => {
                                            try {

                                                dispatch(getMensagensWhatsappDb(leadData?.clienteWhatsapp?.sessao, value.numero, 1, 10));
                                                dispatch(setChatInfo(value));
                                                dispatch(getChatInfoByChatId(value._id, value.funil_id, user.id, true));
                                            } catch (error) {
                                                console.log(error)
                                            }
                                        }}

                                    />
                                </TabsContent>
                                <TabsContent value="contatos">
                                    <DrawerContatos
                                        user={user}
                                        cliente={cliente}
                                        lead={leadData}
                                        onEditarContatoId={(value) => editarLead('editar_contato', value)}
                                        callbackCreateContact={() => buscarDetalhesLead(lead._id)}
                                    />
                                </TabsContent>
                                <TabsContent value="atividades">
                                    <Scrollbar sx={{ height: '50vh', mb: 3 }}>
                                        <DrawerNegocioTimeline data={leadData?.historico} />
                                    </Scrollbar>
                                </TabsContent>
                                <TabsContent value="comentarios">
                                    <DrawerNegocioNotas refreshLead={() => buscarDetalhesLead(lead._id)} user={user} dataLead={leadData} />
                                </TabsContent>
                            </div>
                        </Tabs>
                    </div>
                    <div
                        className="w-3/4 flex flex-col max-h-[80vh]"
                    >

                        {chatInfo ? (
                            <ChatWindow
                                source="funil.chat"
                                sidebarLeft={sidebarLeft}
                                changeOpenSidebarLeft={() => {
                                    isMobile && setSidebarLeft(!sidebarLeft);
                                }}
                                config={config}
                                chatInfo={chatInfo}
                            />
                        ) : (
                            <div className="flex justify-center items-center h-full bg-slate-50 rounded">
                                <Typography variant="subtitle1" color="text.secondary">
                                    Nenhuma chat vinculado a esse lead
                                </Typography>
                            </div>
                        )}

                    </div>
                </div>


            </DialogContent>
        </Dialog>


    );
}
